import React, { useState } from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';

import Slider from '@material-ui/core/Slider';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import Grid from '@material-ui/core/Grid';

type GenerateTokenDialogProps = {
  open: boolean;
  handleClose: () => void;
  handleClick: (duration: number, durationText: string) => Promise<void>;
  name: string;
};

export const GenerateTokenDialog = (props: GenerateTokenDialogProps) => {
  const { open, handleClose, handleClick, name } = props;
  const [value, setValue] = useState(1);
  const [valueText, setValueText] = useState('1h');

  const valueLabelFormat = (duration = 0) => {
    const hours = `${Math.floor(duration)}h`;
    const minutes = Math.round((duration % 1) * 60);

    if (minutes > 0) return `${hours}${minutes}m`;
    return hours;
  };

  const getDurationMs = () => value * 60 * 60 * 1000;

  const handleChange = (newValue: number) => {
    setValue(newValue);
    setValueText(valueLabelFormat(newValue));
  };

  return (
    <Dialog
      data-testid="generate-token-dialog"
      open={open}
      onClose={handleClose}
      aria-labelledby="generate-token-title"
    >
      <DialogTitle id="generate-token-title">
        Confirm Token Generation
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Do you really want generate SAS token to {name} for{' '}
          <strong>{valueText}</strong>?
        </DialogContentText>
        <Grid container spacing={2}>
          <Grid item>
            <AccessTimeIcon />
          </Grid>
          <Grid item xs>
            <Slider
              value={value}
              onChange={(_e, newValue) => handleChange(newValue as number)}
              step={0.25}
              min={1}
              max={4}
              marks
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          onClick={() => {
            handleClick(getDurationMs(), valueText);
          }}
        >
          Generate
        </Button>
      </DialogActions>
    </Dialog>
  );
};
